import React, { Component } from "react";
import PropTypes from "prop-types";
import ApiRequest from "../../libs/request.js";
//import Hobbies from '../profile/Hobbies';
import Nav from "./Nav";
import FeedNav from "./FeedNav";
import CompanyTypes from "./CompanyTypes";
import { validFile } from "../../libs/functions";
import { toast } from "react-toastify";
import { FcCompactCamera } from "react-icons/fc";
import { FaCamera } from "react-icons/fa";
var companyFormData = new FormData();
class Companies extends Component {
  constructor(props) {
    super(props);
    this.state = {
      new: false,
      company: {},
      uploaderMode: "cover",
      companies: [],
      company_types: [],
    };
    this.handleFileUpload = this.handleFileUpload.bind(this);
    this.handleDeleteCompany = this.handleDeleteCompany.bind(this);
  }

  static get propTypes() {
    return {
      user: PropTypes.any,
    };
  }

  render() {
    if (this.state.new) {
      return this.companyForm();
    } else {
      return this.companyList();
    }
  }

  companyForm() {
    var _backgroundImage = {};
    var _backgroundImagePrompt = {
      backgroundImage: 'url("./images/placeholder_2.jpg")',
      width: "100%",
      height: "100%",
      textAlign: "center",
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
    };
    var _avatar = {};
    var _avatarPrompt = {};
    if (this.state.company["cover"]) {
      _backgroundImage = {
        backgroundImage: 'url("' + this.state.company["cover"] + '")',
      };
      _backgroundImagePrompt = { visibility: "hidden" };
    }
    if (this.state.company["profile"]) {
      _avatar = {
        backgroundImage: 'url("' + this.state.company["profile"] + '")',
      };
      _avatarPrompt = { visibility: "hidden" };
    }
    return (
      <React.Fragment>
        <Nav user={this.props.user} />
        <div className="feed">
          <div className="row feed-container">
            <div className="col-md-3 col-lg-2 col-sm-12 feed-left">
              <FeedNav user={this.props.user} />
            </div>
            <div className="col-md-9 col-lg-10 col-sm-12 feed-center">
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "flex-start",
                  minHeight: "100vh",
                  padding: "20px",
                  marginTop: "20px",
                }}
              >
                <div
                  style={{
                    width: "100%",
                    maxWidth: "800px",
                    backgroundColor: "#fff",
                    borderRadius: "12px",
                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                    padding: "40px",
                  }}
                >
                  {/* Cover Image Upload */}
                  <div
                    className="image-upload"
                    style={{
                      ...{
                        width: "100%",
                        height: "220px",
                        borderRadius: "8px",
                        cursor: "pointer",
                        marginBottom: "30px",
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        border: "2px dashed #ddd",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        transition: "all 0.2s ease",
                      },
                      ..._backgroundImage,
                    }}
                    onClick={() => this.handleFileClick("cover")}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.borderColor = "#ff9500";
                      e.currentTarget.style.boxShadow =
                        "0 0 0 3px rgba(255, 149, 0, 0.1)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.borderColor = "#ddd";
                      e.currentTarget.style.boxShadow = "none";
                    }}
                  >
                    <div
                      id="backgroundPrompt"
                      style={{
                        ..._backgroundImagePrompt,
                        textAlign: "center",
                        color: "#999",
                        fontSize: "14px",
                      }}
                    >
                      <div style={{ fontSize: "32px", marginBottom: "8px" }}>
                        <FaCamera />
                      </div>
                      Click to upload cover image
                    </div>
                    <input
                      type="file"
                      className="hidden-upload-field"
                      id="cover-image-field"
                      onChange={this.handleFileUpload}
                    />
                  </div>

                  {/* Company Avatar Upload */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginBottom: "40px",
                    }}
                  >
                    <div
                      className="camera-btn"
                      style={{
                        ...{
                          width: "120px",
                          height: "120px",
                          borderRadius: "8px",
                          cursor: "pointer",
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                          backgroundRepeat: "no-repeat",
                          border: "3px solid #ff9500",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          transition: "all 0.2s ease",
                        },
                        ..._avatar,
                      }}
                      onClick={() => this.handleFileClick("profile")}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.boxShadow =
                          "0 4px 12px rgba(255, 149, 0, 0.2)";
                        e.currentTarget.style.transform = "scale(1.05)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.boxShadow = "none";
                        e.currentTarget.style.transform = "scale(1)";
                      }}
                    >
                      <div
                        id="avatar"
                        style={{
                          ..._avatarPrompt,
                          textAlign: "center",
                          color: "#ff9500",
                          fontSize: "32px",
                        }}
                      >
                        <FaCamera />
                      </div>
                    </div>
                    <input
                      type="file"
                      className="hidden-upload-field"
                      id="profile-image-field"
                      onChange={this.handleFileUpload}
                    />
                  </div>

                  {/* Company Information Form */}
                  <h2
                    style={{
                      margin: "0 0 30px 0",
                      fontSize: "24px",
                      fontWeight: "700",
                      color: "#000",
                      borderBottom: "2px solid #ff9500",
                      paddingBottom: "12px",
                      display: "inline-block",
                    }}
                  >
                    Company Information
                  </h2>

                  <form id="profileForm" className="gorilla-form">
                    {/* Company Name & Address Row */}
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        gap: "20px",
                        marginBottom: "20px",
                      }}
                    >
                      <div>
                        <label
                          style={{
                            display: "block",
                            marginBottom: "8px",
                            fontSize: "14px",
                            fontWeight: "600",
                            color: "#333",
                          }}
                        >
                          Company Name
                        </label>
                        <input
                          id="company_name"
                          defaultValue={this.state.company["name"] || ""}
                          className="form-control"
                          placeholder="Company Name"
                          style={{
                            padding: "12px",
                            fontSize: "14px",
                            border: "1px solid #ddd",
                            borderRadius: "6px",
                            transition: "all 0.2s ease",
                          }}
                          onFocus={(e) => {
                            e.target.style.borderColor = "#ff9500";
                            e.target.style.boxShadow =
                              "0 0 0 3px rgba(255, 149, 0, 0.1)";
                          }}
                          onBlur={(e) => {
                            e.target.style.borderColor = "#ddd";
                            e.target.style.boxShadow = "none";
                          }}
                        />
                      </div>
                      <div>
                        <label
                          style={{
                            display: "block",
                            marginBottom: "8px",
                            fontSize: "14px",
                            fontWeight: "600",
                            color: "#333",
                          }}
                        >
                          Address
                        </label>
                        <input
                          id="address"
                          defaultValue={this.state.company["address"] || ""}
                          className="form-control"
                          placeholder="Address"
                          style={{
                            padding: "12px",
                            fontSize: "14px",
                            border: "1px solid #ddd",
                            borderRadius: "6px",
                            transition: "all 0.2s ease",
                          }}
                          onFocus={(e) => {
                            e.target.style.borderColor = "#ff9500";
                            e.target.style.boxShadow =
                              "0 0 0 3px rgba(255, 149, 0, 0.1)";
                          }}
                          onBlur={(e) => {
                            e.target.style.borderColor = "#ddd";
                            e.target.style.boxShadow = "none";
                          }}
                        />
                      </div>
                    </div>

                    {/* Phone & Email Row */}
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        gap: "20px",
                        marginBottom: "20px",
                      }}
                    >
                      <div>
                        <label
                          style={{
                            display: "block",
                            marginBottom: "8px",
                            fontSize: "14px",
                            fontWeight: "600",
                            color: "#333",
                          }}
                        >
                          Phone
                        </label>
                        <input
                          id="phone"
                          defaultValue={this.state.company["phone"] || ""}
                          className="form-control"
                          placeholder="Phone"
                          style={{
                            padding: "12px",
                            fontSize: "14px",
                            border: "1px solid #ddd",
                            borderRadius: "6px",
                            transition: "all 0.2s ease",
                          }}
                          onFocus={(e) => {
                            e.target.style.borderColor = "#ff9500";
                            e.target.style.boxShadow =
                              "0 0 0 3px rgba(255, 149, 0, 0.1)";
                          }}
                          onBlur={(e) => {
                            e.target.style.borderColor = "#ddd";
                            e.target.style.boxShadow = "none";
                          }}
                        />
                      </div>
                      <div>
                        <label
                          style={{
                            display: "block",
                            marginBottom: "8px",
                            fontSize: "14px",
                            fontWeight: "600",
                            color: "#333",
                          }}
                        >
                          Email
                        </label>
                        <input
                          id="email"
                          defaultValue={this.state.company["email"] || ""}
                          className="form-control"
                          placeholder="Email"
                          style={{
                            padding: "12px",
                            fontSize: "14px",
                            border: "1px solid #ddd",
                            borderRadius: "6px",
                            transition: "all 0.2s ease",
                          }}
                          onFocus={(e) => {
                            e.target.style.borderColor = "#ff9500";
                            e.target.style.boxShadow =
                              "0 0 0 3px rgba(255, 149, 0, 0.1)";
                          }}
                          onBlur={(e) => {
                            e.target.style.borderColor = "#ddd";
                            e.target.style.boxShadow = "none";
                          }}
                        />
                      </div>
                    </div>

                    {/* Company Type */}
                    <div style={{ marginBottom: "20px" }}>
                      <label
                        style={{
                          display: "block",
                          marginBottom: "8px",
                          fontSize: "14px",
                          fontWeight: "600",
                          color: "#333",
                        }}
                      >
                        Company Type
                      </label>
                      <input
                        type="text"
                        id="company_types"
                        className="form-control"
                        placeholder="Company Type"
                        style={{
                          padding: "12px",
                          fontSize: "14px",
                          border: "1px solid #ddd",
                          borderRadius: "6px",
                          transition: "all 0.2s ease",
                        }}
                        onFocus={(e) => {
                          e.target.style.borderColor = "#ff9500";
                          e.target.style.boxShadow =
                            "0 0 0 3px rgba(255, 149, 0, 0.1)";
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor = "#ddd";
                          e.target.style.boxShadow = "none";
                        }}
                      />
                    </div>

                    {/* Description */}
                    <div style={{ marginBottom: "30px" }}>
                      <label
                        style={{
                          display: "block",
                          marginBottom: "8px",
                          fontSize: "14px",
                          fontWeight: "600",
                          color: "#333",
                        }}
                      >
                        Description
                      </label>
                      <textarea
                        id="description"
                        defaultValue={
                          this.state.company["description"] || ""
                        }
                        placeholder="About the company"
                        style={{
                          width: "100%",
                          height: "160px",
                          padding: "12px",
                          fontSize: "14px",
                          border: "1px solid #ddd",
                          borderRadius: "6px",
                          fontFamily: "inherit",
                          transition: "all 0.2s ease",
                          resize: "vertical",
                        }}
                        onFocus={(e) => {
                          e.target.style.borderColor = "#ff9500";
                          e.target.style.boxShadow =
                            "0 0 0 3px rgba(255, 149, 0, 0.1)";
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor = "#ddd";
                          e.target.style.boxShadow = "none";
                        }}
                      />
                    </div>

                    {/* Action Buttons */}
                    <div
                      style={{
                        display: "flex",
                        gap: "12px",
                        justifyContent: "flex-start",
                      }}
                    >
                      <button
                        className="g-button"
                        type="button"
                        onClick={this.handleCompanySave.bind(this)}
                        style={{
                          padding: "12px 32px",
                          backgroundColor: "#ff9500",
                          color: "white",
                          border: "none",
                          borderRadius: "6px",
                          fontSize: "14px",
                          fontWeight: "600",
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.backgroundColor = "#ff8c00";
                          e.target.style.transform = "translateY(-2px)";
                          e.target.style.boxShadow =
                            "0 4px 12px rgba(255, 149, 0, 0.3)";
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.backgroundColor = "#ff9500";
                          e.target.style.transform = "translateY(0)";
                          e.target.style.boxShadow = "none";
                        }}
                      >
                        {this.state.company["id"] ? "Update" : "Save"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }

  handleFileUpload() {
    var imagefile = document.querySelector(
      "#" + this.state.uploaderMode + "-image-field"
    );
    companyFormData.append(
       this.state.uploaderMode,
      imagefile.files[0]
    );
    if (!validFile(imagefile, "photo")) {
      return;
    }

    var reader = new FileReader();
    reader.onload = function (e) {
      if (this.state.uploaderMode === "cover") {
        document.querySelector("#backgroundPrompt").style.visibility = "hidden";
        document.querySelector(".image-upload").style.backgroundImage =
          "url('" + e.target.result + "')";
      } else {
        document.querySelector("#avatar").style.visibility = "hidden";
        document.querySelector(".camera-btn").style.backgroundImage =
          "url('" + e.target.result + "')";
      }
    }.bind(this);

    reader.readAsDataURL(imagefile.files[0]);



    // let apiRequest = new ApiRequest("post", "/users/company");
    // if (this.state.company["id"]) {
    //   apiRequest.method = "put";
    //   apiRequest.url = "/users/company/" + this.state.company["id"];
    // }
    // apiRequest.send_file(formData, (response) => {
    //   let result = response.data;
    //   if (result.errors) {
    //     this.setState({ errors: result.message });
    //   } else {
    //     this.setState({ company: result.data });
    //     if (this.state.uploaderMode === "image") {
    //       document.querySelector("#backgroundPrompt").style.visibility =
    //         "hidden";
    //       document.querySelector(".image-upload").style.backgroundImage =
    //         "url('" + result.data.cover + "')";
    //     } else {
    //       document.querySelector("#avatar").style.visibility = "hidden";
    //       document.querySelector(".camera-btn").style.backgroundImage =
    //         "url('" + result.data.profile + "')";
    //     }
    //   }
    // });
  }

  phonenumber(val) {
    var phoneno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    return val.match(phoneno);
  }

  validateEmail(email) {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
  }

  handleCompanySave() {
    if (document.getElementById("company_name").value.length < 1) {
      toast.error("Please enter a company name");
      return;
    }
    if (document.getElementById("address").value.length < 1) {
      toast.error("Please enter a company address");
      return;
    }
    if (document.getElementById("phone").value.length < 1) {
      toast.error("Please enter a company phone");
      return;
    }
    if (document.getElementById("phone").value.length < 1) {
      toast.error("Please enter a valid phone number");
      return;
    }

    if (document.getElementById("email").value.length < 1) {
      toast.error("Please enter a company email");
      return;
    }

    if (!this.validateEmail(document.getElementById("email").value)) {
      toast.error("Please enter a valid email address");
      return;
    }

    // if (this.state.companytypes.length < 1) {
    //   alert("Please select a company type");
    //   return;
    // }

    let apiRequest = new ApiRequest("post", "/user/add-company");
    if (this.state.company["id"]) {
      apiRequest.method = "post";
      apiRequest.url = "/user/update-company/" + this.state.company["id"];
    }
    // let params = {
    //   name: document.getElementById("company_name").value,
    //   address: document.getElementById("address").value,
    //   phone: document.getElementById("phone").value,
    //   email: document.getElementById("email").value,
    //   description: document.getElementById("description").value,
    // };
    // params["types[]"] = [121, 212];

    companyFormData.append("name", document.getElementById("company_name").value);
    companyFormData.append("address", document.getElementById("address").value);
    companyFormData.append("phone", document.getElementById("phone").value);
    companyFormData.append("email", document.getElementById("email").value);
    companyFormData.append("description", document.getElementById("description").value);
    // companyFormData.append("types[]", document.getElementById("company_types").value);
    companyFormData.append("types[]", [121, 212]);

    apiRequest.send_file(companyFormData, (response) => {
      if (!response || !response.data) {
        toast.error("An error occurred while saving the company.");
        return;
      }
      let result = response.data;
      if (result.errors) {
        this.setState({ errors: result.message });
        toast.error(result.message);
      } else {
        window.location.href = "/companies";
      }
    });
  }

  handleFileClick(uploader) {
    document.getElementById(uploader + "-image-field").click();
    this.setState({ uploaderMode: uploader });
  }
  companyList() {
    var _companies = [];
    this.state.companies.map((c, idx) => {
      var url = "/companies/edit/" + c.id;
      var name = c.name.length > 0 ? c.name : "My company " + c.id;
      _companies.push(
        <div
          key={idx}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "16px",
            marginBottom: "12px",
            backgroundColor: "#f9f9f9",
            borderRadius: "8px",
            border: "1px solid #e8e8e8",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)",
            transition: "all 0.2s ease",
            cursor: "pointer",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)";
            e.currentTarget.style.borderColor = "#ff9500";
            e.currentTarget.style.backgroundColor = "#fff";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.05)";
            e.currentTarget.style.borderColor = "#e8e8e8";
            e.currentTarget.style.backgroundColor = "#f9f9f9";
          }}
        >
          {/* Company Info */}
          <div style={{ display: "flex", alignItems: "center", gap: "16px", flex: 1 }}>
            <a href={url} style={{ textDecoration: "none" }}>
              <img
                src={c.profile}
                alt="Company"
                style={{
                  height: "50px",
                  width: "50px",
                  borderRadius: "6px",
                  objectFit: "cover",
                  border: "2px solid #f0f0f0",
                  cursor: "pointer",
                }}
              />
            </a>
            <div>
              <a
                href={url}
                style={{
                  textDecoration: "none",
                  color: "#000",
                }}
              >
                <p
                  style={{
                    margin: "0",
                    fontWeight: "600",
                    fontSize: "16px",
                    color: "#000",
                    cursor: "pointer",
                  }}
                >
                  {name}
                </p>
              </a>
            </div>
          </div>

          {/* Action Buttons */}
          <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
            <a
              href={url}
              style={{
                padding: "8px 16px",
                backgroundColor: "#ff9500",
                color: "white",
                border: "none",
                borderRadius: "6px",
                fontSize: "13px",
                fontWeight: "600",
                cursor: "pointer",
                whiteSpace: "nowrap",
                transition: "all 0.2s ease",
                textDecoration: "none",
                display: "inline-block",
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = "#ff8c00";
                e.target.style.transform = "translateY(-2px)";
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = "#ff9500";
                e.target.style.transform = "translateY(0)";
              }}
            >
              EDIT
            </a>
            <button
              style={{
                padding: "8px 16px",
                backgroundColor: "#F5F5F5",
                color: "#f44336",
                border: "1px solid #f44336",
                borderRadius: "6px",
                fontSize: "13px",
                fontWeight: "600",
                cursor: "pointer",
                whiteSpace: "nowrap",
                transition: "all 0.2s ease",
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = "#f44336";
                e.target.style.color = "#fff";

                e.target.style.transform = "translateY(-2px)";
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = "#F5F5F5";
                e.target.style.color = "#f44336";
                e.target.style.transform = "translateY(0)";
              }}
              type="button"
              onClick={() => this.handleDeleteCompany(c.id)}
            >
              DELETE
            </button>
          </div>
        </div>
      );
    });

    return (
      <React.Fragment>
        <Nav user={this.props.user} />
        <div className="feed">
          <div className="row feed-container">
            <div className="col-md-3 col-lg-2 col-sm-12 feed-left">
              <FeedNav user={this.props.user} />
            </div>
            <div className="col-md-9 col-lg-10 col-sm-12 feed-center">
              <div
              className="companies-mob"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "flex-start",
                  minHeight: "60vh",
                  padding: "20px",
                }}
              >
                <div
                className="mob-frnd-re-cont"
                  style={{
                    width: "100%",
                    // maxWidth: "1000px",
                    backgroundColor: "#fff",
                    borderRadius: "12px",
                    // boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                    padding: "40px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: "30px",
                    }}
                  >
                    <h2
                      style={{
                        margin: "0",
                        fontSize: "26px",
                        fontWeight: "700",
                        color: "#000",
                        borderBottom: "2px solid #ff9500",
                        paddingBottom: "12px",
                        display: "inline-block",
                      }}
                    >
                      Companies
                    </h2>
                    <button
                      style={{
                        padding: "10px 20px",
                        backgroundColor: "#fff",
                        color: "#ff9500",
                        border: "1px solid #ff9500",
                        borderRadius: "6px",
                        fontSize: "14px",
                        fontWeight: "600",
                        cursor: "pointer",
                        whiteSpace: "nowrap",
                        transition: "all 0.2s ease",
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.backgroundColor = "#ff9500";
                        e.target.style.color = "#fff";
                        e.target.style.transform = "translateY(-2px)";
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.backgroundColor = "#fff";
                        e.target.style.color = "#ff9500";
                        e.target.style.transform = "translateY(0)";
                      }}
                      onClick={() => this.setState({ new: true })}
                    >
                      <i className="fas fa-plus-circle" style={{ marginRight: "8px" }} />
                      Add New Company
                    </button>
                  </div>

                  <div style={{ marginTop: "20px" }}>
                    {_companies.length === 0 ? (
                      <div
                        style={{
                          padding: "30px",
                          textAlign: "center",
                          color: "#999",
                          fontSize: "14px",
                          backgroundColor: "#f9f9f9",
                          borderRadius: "8px",
                          border: "1px solid #e8e8e8",
                        }}
                      >
                        No companies found. Create your first company!
                      </div>
                    ) : (
                      _companies
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }

  handleDeleteCompany(id) {
    if (confirm("Are you sure you want to remove this company?")) {
      let api = new ApiRequest("post", "/user/delete-company");
      api.send({
        id: id,
      }, () => {
        api.url = "/user/get-companies";
        api.method = "get";
        api.send({}, (response) => {
          this.setState({ companies: response.data.companies });
        });
      });
    }
  }
  componentDidMount() {
    const id = this.props.match.params.id;
    if (id) {
      let api = new ApiRequest("get", "/user/get-company?company_id=" + id);
      api.send({}, (response) => {
        this.setState({ company: response.data.company, new: true });
      });
    } else {
      let api = new ApiRequest("get", "/user/get-companies");
      api.send({}, (response) => {
        this.setState({ companies: response.data.companies });
      });
    }
  }
}

export default Companies;
